// extracted by mini-css-extract-plugin
module.exports = {"tabs_wrapper":"tabs_tabs_wrapper__3THkS","tab":"tabs_tab__3AjhR","active_tab":"tabs_active_tab__Yfa9O"};